import Dashboard from "./Dashboard";
import Locations from "./Locations";
import EditLocation from "./EditLocation";
import Customers from "./Customers";
import Categories from "./Categories";
import Pushes from "./Pushes";
import EditProduct from "./EditProduct";
import Coupons from "./Coupons";
import Products from "./Products";
import EditCategory from "./EditCategory";
import Settings from "./Settings";
import QrCodes from "./QrCodes";
import EditCoupon from "./EditCoupon";
import EditPush from "./EditPush";
import Modifiers from "./Modifiers";
import EditModifier from "./EditModifier";
import decorateWindow from "../components/decorateWindow";
import Subscribe from "./Subscribe";

export const dashboard = {
  title: "Dashboard",
  component: decorateWindow(Dashboard),
  showInNav: false,
  path: "/",
};

export const subscribe = {
  title: "Subscribe",
  component: decorateWindow(Subscribe),
  showInNav: false,
  path: "/subscribe",
};

export const locations = {
  title: "Locations",
  component: decorateWindow(Locations),
  path: "/:restaurantId/locations",
};

export const restaurantMenu = {
  title: "Menu",
  component: decorateWindow(Products),
  path: "/:restaurantId/menu",
};

export const customers = {
  title: "Customers",
  component: decorateWindow(Customers),
  path: "/customers",
};

export const coupons = {
  title: "Deals",
  component: decorateWindow(Coupons),
  path: "/:restaurantId/coupons",
};

export const editCoupon = {
  title: "Edit Deal",
  component: decorateWindow(EditCoupon),
  path: "/:restaurantId/edit-coupon/:couponId",
};
export const createCoupon = {
  title: "Create Coupon",
  component: decorateWindow(EditCoupon),
  path: "/:restaurantId/create-coupon",
};

export const push_notifications = {
  title: "Push Notifications",
  component: decorateWindow(Pushes),
  path: "/:restaurantId/pushes",
};

export const createPush = {
  title: "Create Push",
  component: decorateWindow(EditPush),
  path: "/:restaurantId/create-push",
};

export const editProduct = {
  title: "Edit Product",
  component: decorateWindow(EditProduct),
  path: "/:restaurantId/edit-product/:productId",
};

export const createProduct = {
  title: "Create Product",
  component: decorateWindow(EditProduct),
  path: "/:restaurantId/create-product",
};

export const editLocation = {
  title: "Edit Location",
  component: decorateWindow(EditLocation),
  path: "/:restaurantId/edit-location/:locationId",
};

export const createLocation = {
  title: "Create Location",
  component: decorateWindow(EditLocation),
  path: "/:restaurantId/create-location",
};

export const categories = {
  title: "Categories",
  component: decorateWindow(Categories),
  path: "/:restaurantId/categories",
};

export const editCategory = {
  title: "Edit Category",
  component: decorateWindow(EditCategory),
  path: "/:restaurantId/edit-category/:categoryId",
};
export const createCategory = {
  title: "Create Category",
  component: decorateWindow(EditCategory),
  path: "/:restaurantId/create-category",
};

export const settings = {
  title: "Settings",
  component: decorateWindow(Settings),
  path: "/:restaurantId/settings",
};

export const createRestaurant = {
  title: "Create Restaurant",
  component: decorateWindow(Settings),
  paths: "/create-restaurant",
};

export const modifiers = {
  title: "Modifiers",
  component: decorateWindow(Modifiers),
  path: "/:restaurantId/modifiers",
};

export const editModifiers = {
  title: "Edit Modifier",
  component: decorateWindow(EditModifier),
  path: "/:restaurantId/edit-modifier/:modifierId",
};

export const createModifiers = {
  title: "Create Modifier",
  component: decorateWindow(EditModifier),
  path: "/:restaurantId/create-modifier",
};

export const qrcodes = {
  title: "QR Codes",
  component: decorateWindow(QrCodes),
  path: "/:restaurantId/qrcodes",
};



// WEBPACK FOOTER //
// ./src/pages/index.js